export default [
  { key: 'primary_processor_reference', val: 'Processor Reference:' },
  { key: 'external_tag', val: 'External Tag:' },
  { key: 'account_id', val: 'Account ID'},
];
